module.exports = function(s) {


           
    if(this.orderField == s) {

        if(this.orderBy == 'asc') {

            this.orderBy = 'desc';
        } else {
            this.orderBy = 'asc';
        }  

        
    } else {
        this.orderField = s;
        this.orderBy = 'asc';
    }

    console.log('sort');
    console.log('by field '+s);
    console.log('order '+this.orderBy);

    this.pagination.activePage = 1;

    this.getData();

}